import Timer from './modules/Timer';
export default Timer;
